import root from './root.json'
import auth from './auth'
import pages from './pages'
import posts from './posts'

export default { root, auth, pages, posts }